import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';
export const Img = styled('img', {
  shouldForwardProp: shouldForwardProp()
})(({
  isPlaceholderVisible
}) => ({
  visibility: isPlaceholderVisible ? 'hidden' : 'visible'
}));
//# sourceMappingURL=styles.js.map